import React from 'react';
import { Formik } from 'formik';
import { useGetAllAiFeedbackReasonsSuspense } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import NegativeRatingForm from './NegativeRatingForm';
const initialValues = {
    description: '',
    reasons: [],
};
const NegativeRatingFormWrapper = ({ onCancel, onSubmit }) => {
    const { data: reasonsResponse } = useGetAllAiFeedbackReasonsSuspense({
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const reasons = unwrapModel(reasonsResponse);
    if (!reasons)
        return null;
    return (React.createElement(Formik, { initialValues: initialValues, onSubmit: onSubmit },
        React.createElement(NegativeRatingForm, { reasons: reasons, onCancel: onCancel })));
};
export default NegativeRatingFormWrapper;
